import { MigrateFunctionBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { modelVersion, modelVersions } from '../__generated/model/index.js';
import { migrateToV2 } from './v02.js';
import { migrateToV3 } from './v03.js';
import { migrateToV4 } from './v04.js';
import { migrateToV5 } from './v05.js';
import { migrateToV6 } from './v06.js';
import { migrateToV7 } from './v07.js';
import { migrateToV8 } from './v08.js';
import { migrateToV9 } from './v09.js';
import { migrateToV10 } from './v10.js';
import { migrateToV11 } from './v11.js';
export const migrations = {
    2: migrateToV2,
    3: migrateToV3,
    4: migrateToV4,
    5: migrateToV5,
    6: migrateToV6,
    7: migrateToV7,
    8: migrateToV8,
    9: migrateToV9,
    10: migrateToV10,
    11: migrateToV11
};
export const migrateState = MigrateFunctionBuilder.fromVersions(modelVersions).to(modelVersion).using(migrations).build();

//# sourceMappingURL=index.js.map